import { render, staticRenderFns } from "./AutoRefresh.vue?vue&type=template&id=5addba0e&scoped=true&"
import script from "./AutoRefresh.vue?vue&type=script&lang=ts&"
export * from "./AutoRefresh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addba0e",
  null
  
)

export default component.exports